
import './App.css';

function App() {
  return (
    <div className="w-full grow h-full min-h-screen  justify-center items-center relative bg-[#010C15] p-6 flex flex-col">
      <head>
        <link rel="icon" href="/fav.png" />
        <title>Alok J Kashyap</title>
        <meta name="description" content="developer" />
        <meta property="og:url" content="https://azaek.xyz/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Alok J Kashyap" />
        <meta property="og:description" content="developer" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
        <meta property="og:image" content="https://azaek.xyz/og_s.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="azaek.xyz" />
        <meta property="twitter:url" content="https://azaek.xyz/" />
        <meta name="twitter:title" content="Alok J Kashyap" />
        <meta name="twitter:description" content="developer" />
        <meta name="twitter:image" content="https://azaek.xyz/og.png" />
      </head>
      <div className='sm:hidden flex absolute mx-auto inset-x-0 left-0 top-0 aspect-video w-screen bg-gradient-to-br from-[#43d9ad] rotate-45 to-[#4d5bce] rounded-full scale-75 translate-y-[50%] blur-[150px]'>
      </div>
      <main className='w-full flex flex-col gap-6 max-w-sm relative overflow-hidden rounded-lg bg-[#011627] border border-[#1E2D3D] '>
        <div className='w-full aspect-video overflow-clip'>
          <img src="/og.png" className="w-full h-full object-cover overflow-clip" alt='' />
        </div>
        <p className='tc px-6'>This portfolio has been moved to </p>
        <a href='https://azaek.xyz/' className='text-[#4D5BCE] px-6 pb-6' >https://azaek.xyz ↗</a>
      </main>

    </div>
  );
}

export default App;
